import { MAT_DATE_LOCALE } from '@angular/material/core';
import { es } from 'date-fns/locale/es';

export const MatDateLocaleProvider = {
  provide: MAT_DATE_LOCALE,
  useValue: es,
};
